module.exports = __webpack_public_path__ + "img/app-download.0f5f31f2.png";